import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import ColumnEnum from '@/global/components/DataGrid/utils/columEnum'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { SN } from '@acme/core'
import dayjs from 'dayjs'
import { FucionarioCentroCustoExluir } from '../organismos/forms/CentroCusto/Exluir'

export const columnsFuncionarios: GridColDefPro[] = [
    {
        field: 'id',
        headerName: 'ID',
    },
    {
        field: 'nome',
        headerName: 'Nome',
        flex: 1,
        minWidth: 200,
    },
    {
        field: 'cpf',
        headerName: 'CPF',
        width: 160,
        valueFormatter: ({ value }) =>
            value
                ?.toString()
                .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4'),
    },
    {
        field: 'pis',
        headerName: 'PIS',
        width: 160,
        valueFormatter: ({ value }) =>
            value
                ?.toString()
                .replace(/(\d{3})(\d{5})(\d{2})(\d{1})/, '$1.$2.$3-$4'),
    },
    {
        field: 'matricula',
        headerName: 'Matrícula',
        width: 80,
        type: 'number',
    },
    {
        field: 'dtAdmissao',
        headerName: 'Data de admissão',
        type: 'date',
        valueGetter: ({ value }) =>
            !value ? null : dayjs(value).utc().format('YYYY-MM-DD'),
        valueFormatter: ({ value }) =>
            !value ? null : dayjs(value).format('DD/MM/YYYY'),
        width: 130,
    },
    {
        field: 'TabelaHorario',
        headerName: 'Tabela de horário (hoje)',
        width: 200,
        valueGetter: ({ value }) => value?.nome ?? 'Nenhuma (Horista)',
    },
    {
        field: 'RegrasCalculo',
        headerName: 'Regra de cálculo',
        width: 200,
        valueGetter: ({ value }) => value?.nome,
    },
]

export const columnsCentroCusto: GridColDefPro[] = [
    {
        field: 'CentroCusto',
        headerName: 'Centro de Custo',
        width: 246,
        disableColumnMenu: true,
        valueGetter: ({ value }) =>
            value.nomeCentroCusto + ' - ' + value.codigo,
    },
    {
        field: 'dtInicial',
        headerName: 'Data Inicial',
        width: 160,
        disableColumnMenu: true,
        editable: true,
        type: 'date',
        valueGetter: ({ value }) => {
            return value ? dayjs.utc(value).format('YYYY-MM-DD') : null
        },
        valueFormatter: ({ value }) =>
            value ? dayjs.utc(value).format('DD/MM/YYYY') : null,
    },
    {
        field: 'dtFinal',
        headerName: 'Data Final',
        width: 160,
        disableColumnMenu: true,
        editable: true,
        type: 'date',
        valueGetter: ({ value }) => {
            return value ? dayjs.utc(value).format('YYYY-MM-DD') : null
        },
        valueFormatter: ({ value }) =>
            value ? dayjs.utc(value).format('DD/MM/YYYY') : null,
    },
    {
        ...optionsColumn,
        field: '__excluir',
        renderCell: FucionarioCentroCustoExluir,
    },
]

export const columnsFiltrosFuncionarios: GridColDefPro[] = (
    [
        {
            field: 'dtRescisao',
            headerName: 'Data de rescisão',
            type: 'date',
            valueGetter: ({ value }) =>
                !value ? null : dayjs(value).utc().format('YYYY-MM-DD'),
            valueFormatter: ({ value }) =>
                !value ? null : dayjs(value).format('DD/MM/YYYY'),
        },
        {
            field: 'funcao',
            headerName: 'Função',
        },
        {
            field: 'cidade',
            headerName: 'Cidade',
            valueGetter: ({ row }) => row.Cidade?.cidade,
        },
        {
            field: 'estado',
            headerName: 'Estado',
            valueGetter: ({ row }) => row.Cidade?.estado,
        },
        {
            field: 'entradaEntre231',
            headerName: 'Entrada entre 23:00 e 01:00',
            valueGetter: ({ value }) => SN.isTrue(value),
            type: 'boolean',
        },
        {
            field: 'controlarBancoHoras',
            headerName: 'Controla banco de horas',
            valueGetter: ({ row }) =>
                SN.isTrue(row.RegrasCalculo.controlarBancoHoras),
            type: 'boolean',
        },
        {
            field: 'registroApp',
            headerName: 'Pode registrar pelo app',
            valueGetter: ({ value }) => SN.isTrue(value),
            type: 'boolean',
        },
        {
            field: 'registroWeb',
            headerName: 'Pode registrar pelo site',
            valueGetter: ({ value }) => SN.isTrue(value),
            type: 'boolean',
        },
        {
            field: 'pontoDiferenciado',
            headerName: 'Ponto diferenciado',
            type: new ColumnEnum([
                { label: 'Normal', value: 'NORMAL' },
                { label: 'Pré-assinalado', value: 'PRE_ASSINALADO' },
                { label: 'Por exceção', value: 'EXCECAO' },
                { label: 'Sem intervalo', value: 'SEM_INTERVALO' },
            ]),
        },
        {
            field: 'reconhecimentoFacial',
            headerName: 'Usa reconhecimento facial',
            valueGetter: ({ value }) => value > 0,
            type: 'boolean',
        },
        {
            field: 'temAjustesPendentes',
            headerName: 'Tem ajustes pendentes',
            type: 'boolean',
            valueGetter: ({ value }) => value?.toString(),
        },
    ] as GridColDefPro[]
).map(col => ({ ...col, hide: true }))
